import { render, staticRenderFns } from "./agentDistributionRule.vue?vue&type=template&id=02c85afc&scoped=true&"
import script from "./agentDistributionRule.vue?vue&type=script&lang=js&"
export * from "./agentDistributionRule.vue?vue&type=script&lang=js&"
import style0 from "./agentDistributionRule.vue?vue&type=style&index=0&id=02c85afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c85afc",
  null
  
)

component.options.__file = "agentDistributionRule.vue"
export default component.exports